import React, { useEffect, useState } from "react";
import { callAPI, useAPI } from "../../../lib/common";
import { useAuth } from "../../providers/AuthProvider";

const RecentImagesContext = React.createContext();

const RecentImagesProvider = (props) => {
  const [recentImages, setRecentImages] = useState(null);
  const [loadingImages, setLoadingImages] = useState(true);
  const { user } = useAuth();

  // Reload images on user change:
  useEffect(() => {
    if (!user) {
      setRecentImages([]);
      return;
    }
    setLoadingImages(true);
    callAPI("/api/webshop/user/recent-images")
      .then((recentImages) => {
        setRecentImages(recentImages);
      })
      .catch((err) => {
        setRecentImages(recentImages);
      })
      .finally(() => {
        setLoadingImages(false);
      });
  }, [user]);

  const addImage = (image) => {
    setRecentImages((recentImages) => {
      return [...recentImages, image];
    });
  };

  const getImageInfoByUuid = (uuid) => {
    return recentImages.find((image) => image.uuid == uuid);
  };

  console.log("Recent images", recentImages);

  return (
    <RecentImagesContext.Provider
      value={{ addImage, loadingImages, recentImages, getImageInfoByUuid }}
      {...props}
    />
  );
};

export const useRecentImages = () => React.useContext(RecentImagesContext);
export default RecentImagesProvider;
